// components
import { PageSectionInner } from '@/components/PageSection';
import { RichText } from '@/components/RichText';

// styles
import {
  DiffWrapper,
  Title,
  DiffGrid,
  DiffItem,
  DiffNumber,
  DiffTitle,
  DiffCopy,
} from './Differentiators.styles';

export function Differentiators({ content }) {
  return (
    <DiffWrapper>
      <PageSectionInner>
        <Title>{content.title}</Title>
        <DiffGrid>
          {content.items.map((item) => (
            <DiffItem key={`differentiator-${item.title}`}>
              <DiffNumber
                $wrap={item.number_style?.includes('wrap')}
                $tight={item.number_style?.includes('tight')}
              >
                {item.number}
              </DiffNumber>
              <DiffTitle>{item.title}</DiffTitle>
              <DiffCopy>
                <RichText content={item.description} />
              </DiffCopy>
            </DiffItem>
          ))}
        </DiffGrid>
      </PageSectionInner>
    </DiffWrapper>
  );
}
